import { colors } from '@ajaibid/components';
import { css } from '@emotion/css';

export const styTopNav = css`
  position: fixed;
  top: 0;
  left: 0;

  display: flex;
  width: 100vw;
  height: 48px;
  background: ${colors.NEUTRAL_0};
  z-index: 999;

  padding: 0 12px;
  justify-content: space-between;
`;

export const styLeftSide = css`
  position: relative;
  display: flex;
  gap: 16px;
`;

export const styAjaibLogo = css`
  cursor: pointer;
  padding: 4px 0;
  height: 100%;
`;

export const styMenu = css`
  display: flex;
  list-style: none;
  padding: 0;
  margin: 0;

  > li {
    display: flex;
    position: relative;

    > ul {
      display: none;
    }

    :hover {
      > ul {
        display: unset;
      }
    }
  }
`;

export const styMenuItem = ({ isActive }) => css`
  padding: 12px 8px 16px 8px;
  font-weight: 700;
  font-size: 14px;
  position: relative;
  overflow: hidden;

  color: ${isActive ? colors.B400 : colors.NEUTRAL_7};

  ::after {
    display: block;
    position: absolute;
    width: 100%;
    height: 4px;
    background: ${colors.B400};
    bottom: ${isActive ? '0' : '-5px'};
    left: 0;
    content: '';
    border-radius: 6px 6px 0px 0px;
  }

  :hover {
    color: ${colors.B400};
    text-decoration: none;
  }
`;

export const stySubmenu = css`
  display: block;
  list-style: none;

  position: absolute;
  top: 100%;
  left: 0;
  padding: 0;
  width: max-content;

  background: ${colors.NEUTRAL_0};
  box-shadow: 0 2px 8px 0 rgba(51, 51, 51, 0.16);

  > li {
    overflow: hidden;
  }
`;

export const stySubmenuItem = ({ isActive }) => css`
  display: block;
  padding: 8px 12px;
  font-weight: 700;
  font-size: 14px;
  position: relative;
  overflow: hidden;

  color: ${isActive ? colors.B400 : colors.NEUTRAL_7};

  &:hover {
    color: ${colors.B400};
    text-decoration: none;
  }
`;

export const styRightSide = css`
  position: relative;
  display: flex;
  padding: 0;
  margin: 0;
  list-style: none;
`;

export const styMessage = ({ hasUnread }) => css`
  display: flex;
  cursor: pointer;
  position: relative;
  align-items: center;

  ::after {
    display: ${hasUnread ? 'block' : 'none'};
    width: 6px;
    height: 6px;
    border-radius: 100%;
    background-color: rgb(255, 49, 46);
    position: absolute;
    right: 2px;
    top: 12px;
    content: '';
  }
`;

export const styMessageWrapper = css`
  position: fixed;
  right: 12px;
  top: 52px;
  width: 360px;

  background: ${colors.NEUTRAL_0};
  box-shadow: 0 2px 8px 0 rgba(51, 51, 51, 0.16);
`;

export const styProfile = ({ isActive }) => css`
  display: flex;
  padding: 10px 10px;
  cursor: pointer;

  > img {
    object-fit: contain;
    border-radius: 50%;
    cursor: pointer;
    width: 28px;
    height: 28px;
    box-sizing: content-box;
    border: ${isActive ? `2px solid ${colors.B400}` : '2px solid transparent'};
    margin-top: -2px;
  }
`;

export const styProfileWrapper = css`
  position: fixed;
  right: 12px;
  top: 52px;
  width: 360px;

  background: ${colors.NEUTRAL_0};
  box-shadow: 0 2px 8px 0 rgba(51, 51, 51, 0.16);
`;

export const styMiddleSide = css`
  flex: 1;
`;
